import classNames from "classnames";
import styles from "./FileGrid.module.scss";
import { Tooltip, message, Spin } from "antd";
import { Breadcrumb } from "antd";
import intl from "react-intl-universal";
import downImg from "@/assets/images/discover/down.png";
import previewImg from "@/assets/images/discover/view.png";
import getFileIcon from "@/utils/getFileIcon";
import { useRef, useEffect, useState } from "react";
import { findNode, getParentInfo } from "@/utils/buildDirectoryTree";
import { dealFileSize } from "@/utils/dealFileSize";
import { downloadPoint, downloadResourceFiles, getResourceFileDownloadUrl } from "@/apis/discover";
import { collectResourceFileUuids } from "@/utils/resourceDownload";
const FileGrid = ({
  directoryTree,
  resourceUuid,
  curData,
  previewFileData,
}) => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setFiles(directoryTree);
  }, [directoryTree]);
  const [breadcrumb, setBreadcrumb] = useState([
    {
      title: "Files",
    },
  ]);
  const handleBreadcrumb = (e, idx) => {
    if (breadcrumb.length === 1) {
      return;
    } else {
      if (idx === breadcrumb.length) {
        return;
      }
      setBreadcrumb(breadcrumb.slice(0, idx + 1));
      if (e.key) {
        let data = findNode(directoryTree, e.key);
        setFiles(data.children);
      } else {
        setFiles(directoryTree);
      }
    }
  };
  const [gridWidth, setGridWidth] = useState(0);
  const gridRef = useRef(null);
  const handleResize = () => {
    if (gridRef.current) {
      const newWidth = (gridRef.current.offsetWidth - 20) / 5;
      setGridWidth(newWidth);
    }
  };

  useEffect(() => {
    if (curData) {
      const parentNodes = getParentInfo(directoryTree, curData.key);
      if (parentNodes.length > 1) {
        let data = parentNodes.slice(0, parentNodes.length - 1);
        setBreadcrumb([
          {
            title: "Files",
          },
          ...data,
        ]);
        setFiles(data[data.length - 1].children);
      }
    }
  }, [curData, directoryTree]);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // 压缩文件
  const compressFile = async (fileUuids) => {
    setLoading(true);
    try {
      await downloadResourceFiles(resourceUuid, fileUuids);
      setPoint(500);
    } catch (error) {
      setLoading(false);
    }
  };
  // 下载埋点
  const setPoint = (time) => {
    setTimeout(() => {
      setLoading(false);
      message.success({
        content: intl.get("File downloading, please wait patiently"),
        duration: 4,
      });
    }, time);
    downloadPoint({
      resourceUuid: resourceUuid,
    })
      .then((res) => {
        // console.log(res)
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const downLoadFile = async (id, children) => {
    if (id === '-') {
      const ids = collectResourceFileUuids(children || []);
      if (ids.length) await compressFile(ids);
      else message.warning("该目录下暂无文件！");
    } else {
      setLoading(true);
      try {
        const url = await getResourceFileDownloadUrl(resourceUuid, id);
        window.location.assign(url);
        setPoint(2000);
      } catch (error) {
        setLoading(false);
      }
    }
  };
  const previewFile = (e) => {
    previewFileData(e);
  };
  const handleItem = (e) => {
    if (e.type === "folder") {
      setFiles(e.children);
      setBreadcrumb([...breadcrumb, { title: e.name, key: e.key }]);
    } else {
      previewFile(e);
    }
  };
  return (
    <div className={styles.gridWrap}>
      <Breadcrumb separator=">">
        {breadcrumb.map((item, index) => {
          return (
            <Breadcrumb.Item
              key={index + item.title}
              onClick={() => handleBreadcrumb(item, index)}
            >
              <span
                style={{
                  cursor:
                    index === breadcrumb.length - 1 ? "default" : "pointer",
                }}
              >
                {item.title}
              </span>
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
      <Spin
        spinning={loading}
        tip={intl.get("File downloading, please wait patiently")}
      >
        <div
          ref={gridRef}
          className={classNames(styles.contentWrap, "flex_box", "flex_wrap")}
        >
          {files.map((item) => {
            return (
              <div
                className={styles.itemWrap}
                key={item.key}
                style={{ width: gridWidth + "px" }}
                onClick={() => handleItem(item)}
              >
                <div className={styles.top}>{getFileIcon(item)}</div>
                <div className={classNames(styles.bottom, "flex_box")}>
                  <span className={styles.name} title={item.name}>
                    {item.name}
                  </span>
                  {item.type === "file" ? (
                    <span>({dealFileSize(item.size)})</span>
                  ) : (
                    ""
                  )}
                  <div className={styles.downBox}>
                    <Tooltip title={intl.get("Share.Download the file")}>
                      <img
                        src={downImg}
                        onClick={(e) => {
                          e.stopPropagation();
                          downLoadFile(item.type === "file" ? item.key : "-",item.children);
                        }}
                      />
                    </Tooltip>
                    <Tooltip title={intl.get("Discover.View")}>
                      {item.type === "file" ? (
                        <img
                          src={previewImg}
                          onClick={(e) => {
                            e.stopPropagation();
                            previewFile(item);
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </Tooltip>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Spin>
    </div>
  );
};

export default FileGrid;
